'use client';
import { createContext } from 'react';
const pageContext = createContext(null);
export default pageContext;
